import { createReducer, createActions } from 'reduxsauce'
import {
  initialFeedback,
  requestFeedback,
  successFeedback,
  failureFeedback,
} from 'reducers/utils'

const INITIAL_STATE = {
  // `/v1/training-policy/me/` completo: etapa, estado, Universidad, horas,
  // facturacion, inventario y proxima evaluacion. `null` hasta la primera
  // respuesta; `status.enabled === false` significa que la politica no
  // aplica a este asesor (contrato sin la politica, plan no elegible, etc).
  status: null,
  statusFeedback: initialFeedback(),
  trainings: [],
  trainingsFeedback: initialFeedback(),
  // feedback del alta de una capacitacion externa
  createFeedback: initialFeedback(),
}

const { Types, Creators } = createActions(
  {
    getTrainingPolicyStatusRequest: [],
    getTrainingPolicyStatusSuccess: ['status'],
    getTrainingPolicyStatusFailure: ['errors'],
    getTrainingsRequest: ['params'],
    getTrainingsSuccess: ['results'],
    getTrainingsFailure: ['errors'],
    createTrainingRequest: ['data'],
    createTrainingSuccess: ['training'],
    createTrainingFailure: ['errors'],
    resetTrainingForm: [],
  },
  { prefix: 'TRAINING_POLICY_' }
)

export const TrainingPolicyTypes = Types
export const TrainingPolicyActionCreators = Creators

const getStatusRequest = state => ({
  ...state,
  statusFeedback: requestFeedback(),
})

const getStatusSuccess = (state, { status }) => ({
  ...state,
  status,
  statusFeedback: successFeedback(),
})

const getStatusFailure = (state, { errors }) => ({
  ...state,
  statusFeedback: failureFeedback(errors),
})

const getTrainingsRequest = state => ({
  ...state,
  trainingsFeedback: requestFeedback(),
})

const getTrainingsSuccess = (state, { results }) => ({
  ...state,
  trainings: results,
  trainingsFeedback: successFeedback(),
})

const getTrainingsFailure = (state, { errors }) => ({
  ...state,
  trainingsFeedback: failureFeedback(errors),
})

const createTrainingRequest = state => ({
  ...state,
  createFeedback: requestFeedback(),
})

/**
 * La capacitacion nueva entra al listado al frente, pero NO mueve el total de
 * horas: nace pendiente de validacion y solo suma cuando un administrador la
 * aprueba (R26-878). El total vive en `status.training`, que se refresca
 * desde el servidor.
 */
const createTrainingSuccess = (state, { training }) => ({
  ...state,
  trainings: [training, ...state.trainings],
  createFeedback: successFeedback(),
})

const createTrainingFailure = (state, { errors }) => ({
  ...state,
  createFeedback: failureFeedback(errors),
})

const resetTrainingForm = state => ({
  ...state,
  createFeedback: initialFeedback(),
})

export default createReducer(INITIAL_STATE, {
  [Types.GET_TRAINING_POLICY_STATUS_REQUEST]: getStatusRequest,
  [Types.GET_TRAINING_POLICY_STATUS_SUCCESS]: getStatusSuccess,
  [Types.GET_TRAINING_POLICY_STATUS_FAILURE]: getStatusFailure,
  [Types.GET_TRAININGS_REQUEST]: getTrainingsRequest,
  [Types.GET_TRAININGS_SUCCESS]: getTrainingsSuccess,
  [Types.GET_TRAININGS_FAILURE]: getTrainingsFailure,
  [Types.CREATE_TRAINING_REQUEST]: createTrainingRequest,
  [Types.CREATE_TRAINING_SUCCESS]: createTrainingSuccess,
  [Types.CREATE_TRAINING_FAILURE]: createTrainingFailure,
  [Types.RESET_TRAINING_FORM]: resetTrainingForm,
})
